export enum OnDemandMediaType {
  WorkshopCatchUp = 'WorkshopCatchUp',
  WorkshopClip = 'WorkshopClip',
  WorkshopSamsonCut = 'WorkshopSamsonCut',
  WorkshopTrailer = 'WorkshopTrailer',
  WorkshopOriginal = 'WorkshopOriginal',
  WorkshopSessionOverview = 'WorkshopSessionOverview',
}
